import { activityActions } from '../../constants';
import { actionTypes } from './constants';

// Action creators pour le slice activityData (reducer.js)
export const resetState = (payload = {}) => ({
  type: activityActions.RESET_STATE,
  payload,
});

export const setSelectedActivity = (activity) => ({
  type: activityActions.SET_SELECTED_ACTIVITY,
  payload: activity,
});

export const setSelectedDuration = (value) => ({
  type: activityActions.SET_SELECTED_DURATION,
  payload: value,
});

export const setShowDisponibilities = (value) => ({
  type: activityActions.SET_SHOW_DISPONIBILITIES,
  payload: value,
});

export const setCourse = (value) => ({
  type: activityActions.SET_COURSE,
  payload: value,
});

export const setActiveOption = (value) => ({
  type: actionTypes.SET_ACTIVE_OPTION,
  payload: value,
});

export const setShowAvailability = (value) => ({
  type: actionTypes.SET_SHOW_AVAILABILITY,
  payload: value,
});

export const setTypes = (value) => ({
  type: actionTypes.SET_TYPES,
  payload: value,
});

export const setTypesFilters = (value) => ({
  type: actionTypes.SET_TYPES_FILTERS,
  payload: value,
});

export const setError = (value) => ({
  type: actionTypes.SET_ERROR,
  payload: value,
});

export const setActivity = (activity) => ({
  type: actionTypes.SET_ACTIVITY,
  payload: activity,
});

export const setDate = (date) => ({
  type: actionTypes.SET_DATE,
  payload: date,
});

export const setDuration = (duration) => ({
  type: actionTypes.SET_DURATION,
  payload: duration,
});

export const setResource = (resource) => ({
  type: actionTypes.SET_RESOURCE,
  payload: resource,
});

export const setPlayers = (players) => ({
  type: actionTypes.SET_PLAYERS,
  payload: players,
});

export const addPlayer = (player) => ({
  type: actionTypes.ADD_PLAYER,
  payload: player,
});

export const removeLastPlayer = () => ({
  type: actionTypes.REMOVE_LAST_PLAYER,
});

export const assignPlayer = (player) => ({
  type: actionTypes.ASSIGN_PLAYER,
  payload: player,
});

export const replacePlayerAt = (player, index) => ({
  type: actionTypes.REPLACE_PLAYER_AT,
  payload: { index, player },
});

export const initState = (state = {}) => ({
  type: actionTypes.INIT_STATE,
  payload: state,
});
